import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import locales from '@/locales';

i18n
    .use(initReactI18next)
    .init({
        resources: locales,
        fallbackLng: 'en',
        debug: process.env.REACT_APP_ENVIRONMENT === 'dev',
        lng: 'en',
        compatibilityJSON: 'v3',
        interpolation: {
            escapeValue: false,
            format: function (value, format, lng) {
                if (typeof value !== 'string') return value;
                switch (format) {
                    case 'capitalize':
                        return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
                    case 'lowercase':
                        return value.toLowerCase();
                    case 'uppercase':
                        return value.toUpperCase();
                    default:
                        return value;
                }
            }
        },
    });


export default i18n;
